import {useMinSpin} from "../../../../../../hooks/useMinSpin";
import {useEffect, useState} from "react";
import Popup from "../../../../../../shared/Popup";
import DropDownPurchase from "../../../../../../shared/DropDowns/DropDownPurchase";
import Toaster from "../../../../../../shared/Toaster";
import axios from "axios";
import {PATHS_API} from "../../../../../../../enum";
import {useUserStore} from "../../../../../../../modules/shop/user/store";
import {ToasterProps} from "../../../../../../shared/Toaster/Toaster";
import {getCurrentDateInSeconds} from "../../../../../../shared/functions/getRandomId";
import ButtonLabel from "../../../../../../shared/ButtonLoader/ButtonLoader";
import ProductImage from "../../../../../../shared/ProductImage/ProductImage";
import {useProductsStore} from "../../../../../../../modules/shop/products/store";
// вікно в тому ж стилі, що й вікно товару в магазині (стилі вмикаються через .wrapper-desc)
import "../../../../../ShopPage/components/Products/Products.scss";


const PopupBasketDesc = (props) => {

    const {data, setActivePopup, activePopup, onRemove, onRefresh, onRefundStateChange} = props
    // повернення цього товару вже в черзі на сервері (наприклад, після оновлення сторінки)
    const refundPending = data.refundStatus === 'pending'
    // предмет з ящика повертається лише за половину ціни (так само рахує сервер)
    const fromLootbox = data.reward === 'lootbox'
    // приз розіграшу видається лише в грі й не повертається (сервер теж це забороняє)
    const fromGiveaway = data.reward === 'giveaway'
    // пріоритет і сети не повертаються, сет можна лише замінити
    const isService = data.product.type === "priority" || data.product.type === "set"
    const refundPrice = fromLootbox ? Math.floor(data.product.price * 0.5) : data.product.price
    const fetchUser = useUserStore(store => store.fetchUser)

    const [isLoading, setIsLoading] = useState(false)
    // спінер видно щонайменше пів секунди (useMinSpin)
    const actionSpin = useMinSpin(isLoading);
    const [toastProps, setToastProps] = useState<ToasterProps | null>(null);

    // const [activeServer, setActiveServer] = useState({_id: data._id, name: data.product.productName});
    const [activeServer, setActiveServer] = useState({_id: "placeholder", name: "Виберіть пресет одягу"});
    const products = useProductsStore(state => state.products)
    const fetchProducts = useProductsStore(state => state.fetchProducts)
    const filterProducts = products.filter(p => p.type === "set" && p.personal !== true)

    useEffect(() => {
        fetchProducts()
    }, [])


    const refund = async (_id: string) => {
        if (isLoading) return;

        setIsLoading(true);
        onRefundStateChange?.(true);

        // Повернення виконується з випадковою затримкою 10-30 секунд. Якщо відповіді ще немає,
        // пояснюємо гравцю, що відбувається (миттєві відмови, наприклад пауза між поверненнями, цього не побачать).
        const hintTimer = setTimeout(() => {
            setToastProps({
                message: "Повернення прийнято в обробку. Це може зайняти до 30 секунд.",
                type: "info",
                id: getCurrentDateInSeconds(),
            });
        }, 1500);

        try {
            const { data } = await axios.put(
                PATHS_API.PURCHASES,
                { _id },
                { withCredentials: true }
            );

            // 202: повернення прийнято, але ще в черзі (його завершить сервер)
            const stillPending = data.status === 202;

            setToastProps({
                message: data.message,
                type: stillPending ? "info" : "success",
                id: getCurrentDateInSeconds(),
            });

            await fetchUser();
            if (!stillPending) {
                await onRemove?.();
            }
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message || "Сталася помилка";

            setToastProps({
                message: errorMessage,
                type: "error",
                id: getCurrentDateInSeconds(),
            });

            // після відмови (наприклад, товар видали в грі) список мусить показати реальний стан
            await onRefresh?.();
        } finally {
            clearTimeout(hintTimer);
            setIsLoading(false);
            onRefundStateChange?.(false);
            setActivePopup(false);
        }
    };

    const changeSet = async (purchaseId: string, newSet: string) => {
        if(activeServer._id === "placeholder") {
            return setToastProps({
                message: activeServer.name + "!",
                type: "error",
                id: getCurrentDateInSeconds(),
            });
        }
        if (isLoading) return;

        setIsLoading(true);

        try {
            const { data } = await axios.put(
                `${PATHS_API.CHANGE_PURCHASES}`,
                { purchaseId, newSet },
                { withCredentials: true }
            );

            setToastProps({
                message: data.message,
                type: "success",
                id: getCurrentDateInSeconds(),
            });

            await fetchUser();
            await onRemove?.();
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message || "Сталася помилка";

            setToastProps({
                message: errorMessage,
                type: "error",
                id: getCurrentDateInSeconds(),
            });
        } finally {
            setIsLoading(false);
            setActivePopup(false);
        }
    };

    return (
        <>
            <Popup
                title={data.product.productName}
                setActivePopup={setActivePopup}
                activePopup={activePopup}
            >
                <div className="wrapper-desc">
                    <div className="purchase-info">
                        <div className="product-desc-img-wrapper">
                            <ProductImage className="product-desc-img" src={data.product.imageUrl} alt="product-img"/>
                            { fromLootbox && <span className="discount-desc-info">-50%</span> }
                        </div>
                        <p className="desc-product">
                            {
                                fromGiveaway && !isService
                                    ? "Це приз з розіграшу, його не можна повернути. Забрати його можна тільки в грі."
                                    : isService
                                    ? "Ви можете замінити цей товар на інший. Якщо новий сет дорожчий — спишеться різниця в ціні. Якщо дешевший або такий самий — просто заміна. Доступно один раз на 60 хвилин."
                                    : fromLootbox
                                        ? `Це предмет з ящика, тому його можна повернути лише за 50% ціни: на баланс повернеться ${refundPrice} ₴ замість ${data.product.price} ₴.`
                                        : "Повернути цей товар можна у будь-який час — кошти повернуться на баланс магазину."
                            }
                        </p>
                        { fromGiveaway && isService &&
                            <p className="desc-product">Це приз з розіграшу, його не можна повернути.</p>
                        }
                        {/* сума повернення — плашка як ціна в магазині */}
                        { !isService && !fromGiveaway &&
                            <div className="quantity-block">
                                <div className="quantity-btn-block bk-modal-refund">
                                    <span className="bk-modal-label">Повернеться на баланс</span>
                                    { refundPrice } ₴
                                </div>
                            </div>
                        }
                        { data.product.type === "set" &&
                            <div className="details-purchase bk-modal-set">
                                <DropDownPurchase
                                    data={filterProducts}
                                    activeOption={activeServer}
                                    setActiveOption={setActiveServer}
                                    width={"100%"}
                                />
                            </div>
                        }
                    </div>
                </div>
                { !isService && !fromGiveaway &&
                    <button
                        onClick={() => {
                            refund(data._id)
                            setActivePopup(false)
                        }}
                        disabled={actionSpin || refundPending}
                        className={`button-buy ${actionSpin ? "btn-loading" : ""}`}
                    >
                        <ButtonLabel loading={actionSpin}>
                            { refundPending ? "Повернення в обробці" : "Повернути товар" }
                        </ButtonLabel>
                    </button>
                }
                { data.product.type === "set" &&
                    <button
                        onClick={() => {
                            changeSet(data._id, activeServer._id)
                            setActivePopup(false)
                        }}
                        disabled={actionSpin}
                        className={`button-buy ${actionSpin ? "btn-loading" : ""}`}
                    >
                        <ButtonLabel loading={actionSpin}>Змінити сет</ButtonLabel>
                    </button>
                }
            </Popup>
            {toastProps && <Toaster message={toastProps.message} type={toastProps.type} id={toastProps.id} />}
        </>
    )
};

export default PopupBasketDesc;